import Api from '../Utils/Axios';

export const GetClientUserListing = async (data) => {
  const response = await Api.get(`clientUser/`, {params:data});
  return response.data;
};

export const updateClientStatus = async (data) => {
  const response = await Api.post('clientUser/status', data);
  return response.data;
};

export const GetSingleClientUser = async (data) => {
  const response = await Api.get(`clientUser/${data.id}`);
  return response.data;
};

export const GetSingleClientUserSubscriptions = async (data) => {
  const { id, page, limit } = data || {};
  const response = await Api.get(`clientUser/${id}/subscriptions`, {
    params: {
      page,
      limit,
    },
  });
  return response.data;
};

export const GiveSubscription = async (data) => {
  const response = await Api.post(`subscription/give`, data)
  return response.data;
}

export const GetPrices = async () => {
  const response = await Api.get(`subscription/prices`)
  return response.data;
}